"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckLtlDryvan = function SvgIconTruckLtlDryvan(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck ltl dryvan icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Ltl Dryvan Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.999 24.43v-5.133h5l3.928 5.134h-8.928zm2 13.352c-1.659 0-3.001-1.383-3.001-3.08 0-1.706 1.342-3.08 3-3.08 1.657 0 3.002 1.374 3.002 3.08 0 1.697-1.345 3.08-3.001 3.08zm-24 0c-1.657 0-3-1.383-3-3.08 0-1.706 1.343-3.08 3-3.08 1.654 0 3 1.374 3 3.08 0 1.697-1.346 3.08-3 3.08zm28.002-21.569h-8.952v12.504h-2.092V8H6c-2.211 0-4 1.832-4 4.108v22.594h4c0 3.398 2.686 6.16 5.999 6.16 3.313 0 6.002-2.762 6.002-6.16h11.998c0 3.398 2.684 6.16 6 6.16 3.313 0 6-2.762 6-6.16H46V24.431l-6-8.218zM5 12a1 1 0 011-1h11a1 1 0 011 1v11a1 1 0 01-1 1H6a1 1 0 01-1-1V12zm5.748 1.24h-2.1V22h5.916v-2.004h-3.816V13.24z"
  }));
};

var _default = SvgIconTruckLtlDryvan;
exports.default = _default;